<template>
  <component
    :is="tag"
    class="max-w-screen-3xl mx-auto w-full px-6 md:px-10"
    :class="{
      'xl:px-22': containedBy === 'container',
      'max-sm:px-4': containedBy === 'content',
    }"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    tag?: keyof HTMLElementTagNameMap;
    containedBy?: "container" | "content";
  }>(),
  {
    tag: "div",
    containedBy: "container",
  },
);
</script>
